"use client";

import { EmptyState } from "@/components/feedback";
import { MicrositeListFetchError } from "@/components/shared/MicrositeListFetchError";
import { Text } from "@/components/ui";
import { useTenantContentSettingsGet } from "@/features/profile-settings/hooks/useTenantContentSettingsGet";
import { ContentSettingsText } from "@/lib/utils/content-settings/ContentSettingsText";
import { useTenantData } from "@/hooks";
import { getTenantDisplayName } from "@/lib/utils/tenant";

interface LocationsPageErrorProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const LocationsPageError = ({
  onRetry,
  isRetrying = false,
}: LocationsPageErrorProps) => {
  return (
    <MicrositeListFetchError
      onRetry={onRetry}
      isRetrying={isRetrying}
      testId="locations-page-retry-button"
    />
  );
};

export const LocationsPageEmpty = () => {
  const { tenantId, tenantData } = useTenantData();
  const { data: contentSettings } = useTenantContentSettingsGet(
    { tenantId },
    { enabled: !!tenantId },
  );

  return (
    <EmptyState
      title={contentSettings.locationsEmptyTitle}
      message={
        <ContentSettingsText
          variant="secondary"
          fontSize="sm"
          textAlign="center"
          studioName={getTenantDisplayName(tenantData)}
          tenantEmail={tenantData?.email}
        >
          {contentSettings.locationsEmptyDescription}
        </ContentSettingsText>
      }
    />
  );
};

export const LocationsPageNoResults = ({
  hasActiveQuery = true,
}: {
  hasActiveQuery?: boolean;
}) => {
  return (
    <EmptyState
      title="No locations found"
      message={
        <Text variant="secondary" fontSize="sm" textAlign="center">
          {hasActiveQuery
            ? "Try a different search or clear the city filter."
            : "No locations match your current view."}
        </Text>
      }
    />
  );
};
